import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=8e7987ee&scoped=true"
import script from "./Image.js?vue&type=script&lang=js&external"
export * from "./Image.js?vue&type=script&lang=js&external"
import style0 from "./Image.scss?vue&type=style&index=0&id=8e7987ee&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7987ee",
  null
  
)

export default component.exports